var React = require('react');

var Select = require('react-bootstrap/lib/SplitButton');
var Option = require('react-bootstrap/lib/MenuItem');

var CourierStatus = React.createClass({

	update(data) {
		this.props.update(data.courierId, {
			status: data.status
		});
	},

	remove(data) {
		this.props.remove(data.courierId);
	},

	getSelectId: function() {
		return 'courierstatus'.concat(Date.now());
	},

	getTitle: function(status) {
		var label;

		switch(status) {
			case 1:
				label = 'Aprovado';
				break;

			default:
				label = 'Pendente';
				break;
		}

		return label;
	},

	render: function() {
		var me = this, 
			status = me.props.data,
			data = me.props.rowData;

    	return (
    		<Select 
				bsStyle='default' 
				bsSize='xsmall' 
				title={me.getTitle(status)} 
				id={me.getSelectId()}
			>
				<Option
					eventKey={{courierId: data.id, status: 0}}
					onSelect={me.update}
				>
					{"Pendente"}
				</Option>

				<Option
					eventKey={{courierId: data.id, status: 1}}
					onSelect={me.update}
				>
					{"Aprovado"}
				</Option>

				<Option 
					eventKey={{courierId: data.id}}
					onSelect={me.remove}
				>
					{"Remover"}
				</Option>
			</Select>
    	)
	}

});

module.exports = CourierStatus;


// WEBPACK FOOTER //
// ./src/components/Admin/Couriers/CourierStatus.jsx